import { jsxs as _, jsx as e } from "@emotion/react/jsx-runtime";
import { DateRangeInputFieldContainer as P, StyledWrapperTextField as C, StyledDateRangeTextField as S, IconResetContainer as v, Notice as N } from "./DateRangeInputField.styled.js";
import { Icon as b } from "../../Icon/index.js";
import { Stack as O } from "../../Stack/index.js";
import { StyledIcon as k } from "../DatePicker.styled.js";
import { useDatePickerContext as U } from "../DatePickerContext.js";
import { formatDate as y, DEFAULT_RANGE_DATE_PLACEHOLDERS as $, DEFAULT_RANGE_LABELS as E, DEFAULT_RANGE_MONTH_PLACEHOLDERS as w } from "../helpers.js";
import { DatePickerInputName as r } from "../../../types/components/dateRangePicker.js";
import { FontAwesomeIconsPartooUsed as I, IconPrefix as G } from "../../../types/components/icon.js";
const K = ({
  labels: n,
  placeholders: d
}) => {
  const {
    dataTrackId: i,
    setActiveInput: c,
    datePickerType: l,
    dates: t,
    activeInput: s,
    handleReset: h,
    displayCalendar: A,
    setDisplayCalendar: p,
    localeDatePicker: D,
    format: f,
    error: a,
    warning: R,
    success: g,
    notice: m,
    refStartDate: x,
    refEndDate: T
  } = U(), F = (o) => {
    c(r.StartDate), p(!0), o.stopPropagation();
  }, L = (o) => {
    c(r.EndDate), p(!0), o.stopPropagation();
  }, u = {
    startDate: y(t?.[0], D.name, f),
    endDate: y(t?.[1], D.name, f)
  };
  return /* @__PURE__ */ _(O, { gap: "4px", children: [
    /* @__PURE__ */ _(P, { focus: A, success: g, error: a, warning: R, children: [
      /* @__PURE__ */ e(k, { disabled: !1, icon: ["fa-calendar-days"], color: "secondary", iconSize: "16px" }),
      /* @__PURE__ */ e(C, { onClick: F, children: /* @__PURE__ */ e(S, { dataTrackId: "date_range_input_field_start", valueContainer: !0, id: "date-from", value: u.startDate, type: "text", label: n?.startDate ?? E.startDate, placeholder: d?.startDate ?? $.startDate, edit: !1, autoComplete: "off", hasFocusStyle: s === r.StartDate, ref: x }) }),
      /* @__PURE__ */ e(k, { disabled: !1, icon: [I.faArrowRight], color: "secondary", iconSize: "16px" }),
      /* @__PURE__ */ e(C, { onClick: L, children: /* @__PURE__ */ e(S, { dataTrackId: "date_range_input_field_end", valueContainer: !0, id: "date-end", "data-track": `${i}__${l}__date-end`, value: u.endDate, type: "text", label: n?.endDate ?? E.endDate, placeholder: d?.endDate ?? w.endDate, isReset: !1, edit: !1, autoComplete: "off", hasFocusStyle: s === r.EndDate, ref: T }) }),
      /* @__PURE__ */ e(v, { onClick: h, children: t && (!!t[0] || !!t[1]) && /* @__PURE__ */ e(b, { dataTrackId: `${i}__${l}__reset`, icon: [I.faCircleXmark, G.SOLID], color: "secondary" }) })
    ] }),
    (a || m) && /* @__PURE__ */ e(N, { as: "span", variant: "bodySRegular", color: a ? "danger" : "secondary", children: a ?? m })
  ] });
};
export {
  K as DateRangeInputField
};
